import React from 'react';
import { useTranslation } from 'next-i18next';

import Button, { ButtonProps } from '../Button';

import { Content, SignOutIcon } from './styled';

type LogoutButtonProps = Omit<ButtonProps, 'children'>;

const LogoutButton: React.FC<LogoutButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Button {...props} color="link">
      <Content>
        {t('logoutButtonText')}
        <SignOutIcon />
      </Content>
    </Button>
  );
};

export default LogoutButton;
